import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map, pairwise } from 'rxjs/operators';
import { EncryptDutyFreePreOrderRequest, DefaultService as api } from 'src/sdk-servicing';
import { ServicingBaseClass } from '@common/components';
import {
  EncryptDutyFreePreorderResultState,
  EncryptDutyFreePreorderResultStore,
  resetEncryptDutyFreePreorderResult,
  selectEncryptDutyFreePreorderResultState,
  setEncryptDutyFreePreorderResultFromApi,
} from '@common/store/encrypt-duty-free-preorder-result';

@Injectable()
export class EncryptDutyFreePreorderResultStoreService extends ServicingBaseClass {
  /** 免税品プリオーダー連携パラメータ暗号化APIのレスポンス */
  private _result$ = this._store.pipe(
    select(selectEncryptDutyFreePreorderResultState),
    pairwise(),
    filter(([prev, curr]) => prev.isPending === true && curr.isPending === false),
    map(([_, cur]) => cur)
  );

  /**
   * エラーが発生していない免税品プリオーダー連携パラメータ暗号化APIのレスポンス通知
   */
  get success$(): Observable<EncryptDutyFreePreorderResultState> {
    return this._result$.pipe(filter((state) => state.isFailure === false));
  }

  /**
   * エラーが発生している免税品プリオーダー連携パラメータ暗号化APIのレスポンス通知
   */
  get failure$(): Observable<EncryptDutyFreePreorderResultState> {
    return this._result$.pipe(filter((state) => state.isFailure === true));
  }

  constructor(private _store: Store<EncryptDutyFreePreorderResultStore>, private api: api) {
    super();
  }

  override destroy(): void {
    this.clear();
  }

  /**
   * 免税品プリオーダー連携パラメータ暗号化APIを呼び出す
   * @param parameter 免税品プリオーダー連携パラメータ暗号化APIのリクエストパラメータ
   */
  request(parameter: EncryptDutyFreePreOrderRequest): void {
    const call = this.api.ordersEncryptDutyFreePreOrderPost(parameter);
    this._store.dispatch(setEncryptDutyFreePreorderResultFromApi({ call }));
  }

  /**
   * 免税品プリオーダー連携パラメータ暗号化取得結果ストアをクリアする
   */
  clear(): void {
    this._store.dispatch(resetEncryptDutyFreePreorderResult());
  }
}
